module.exports = __webpack_public_path__ + "img/9788959065127.7ec75140.jpg";